export enum AddAccountScreenName {
    PASSCODE = 'passcodeScreen',
    PHONE = 'phoneScreen',
    AUTH_APP = 'authAppScreen',
    EMAIL_VERIFICATION = 'emailVerificationScreen',
    TRUST_BROWSER = 'trustBrowserScreen',
}
